import styled from 'styled-components';

export const StyledUserActions = styled.div`
    display: flex;
    flex-direction: column;

    .wrapper {
        width: 50%
    }
    
    .container {
        display: flex;
        gap: 25px;
        margin: 20px 0;

        .dropdown, .input {
            width: 100%;
            flex-grow: 1 0 auto;
        }
    }

    .bllink-button {
        width: 300px;
        align-self: flex-start;
    }
`